document.addEventListener('rebuy:smartcart.ready',
function() {
    let SmartCart = window.Rebuy.SmartCart;
    console.log("SmartCart", SmartCart);
    
    const count = SmartCart.itemCount();
    const cartCounter = document.getElementsByClassName('header__btn-cart-amount');
    console.log("cart Counter", count, cartCounter[0]);
    cartCounter[0].innerHTML = count;  
  
    if (window.location.pathname.includes('/products/')){
      if(document.querySelector('#add-pdp-button')){
        pdpATC = document.querySelector('#add-pdp-button');
        // Rebuy load enable PDP ATC button
        //pdpATC.classList.add('ready');
        
        // open cart on PDP ATC click
        if(!pdpATC.classList.contains('is-hidden')){
          pdpATC.addEventListener('click', () => {
            setTimeout(()=>{
              const cartWindow  = document.getElementsByClassName('rebuy-cart');
              cartWindow[0].classList.add('is-visible');
              console.log('open delay')
             }, 500)
          })
        }
      }
    }
});
function showCart() {
    // let SmartCart = window.Rebuy.SmartCart;
    // const showCart = SmartCart.show()
    // console.log("SmartCart", showCart);
    const cartWindow  = document.getElementsByClassName('rebuy-cart');
    cartWindow[0].classList.add('is-visible');
};
function hideCart() {
    // let SmartCart = window.Rebuy.SmartCart;
    // const showCart = SmartCart.show()
    // console.log("SmartCart", showCart);
    const cartWindow  = document.getElementsByClassName('rebuy-cart');
    cartWindow[0].classList.remove('is-visible');
};

(() => {
  if (window.location.pathname.includes('/products/')){
    let interval,
    counter = 0,
    duration = 250,
    limit = 80;
    interval = setInterval( () => {
      if (document.getElementsByClassName('product-size').length > 0){
        if (document.getElementsByClassName('product-size')[0].getElementsByClassName('custom-select').length > 0) {
            // Rebuy load enable PDP ATC button
            let pdpATC = document.querySelector('#add-pdp-button');
            pdpATC.classList.add('ready');
          clearInterval( interval );
        }
      } else if ( counter === limit ) {
        clearInterval ( interval );
      } 
    }, duration );
  }
})();

document.addEventListener("DOMContentLoaded", function(event) {
  //if (window.location.pathname.includes('/collections/stylest-x-lola-the-boys')){
	Array.from(document.getElementsByClassName('product-card')).forEach( el => {
		if(el.hasAttribute('data-ext-url')){
			Array.from(el.getElementsByTagName('a')).forEach(a => {
				a.href = el.dataset.extUrl;
				a.setAttribute('target','_blank');
			})
		}
	})
  //}
});